import {
  takeLatest, call, put, cancel, SagaReturnType,
} from 'redux-saga/effects';
import camelcaseKeys from 'camelcase-keys';

import { select } from 'app/store/utils/saga/effects';

import * as giftActions from '../actions';
import { ICashItem, IServerCashItemsResponse } from '../interfaces';

export const config = {
  action: giftActions.cashLoadData.type,
  method: takeLatest,
};

const getGiftList = async (amount: number, giftCardId?: number | null): Promise<ICashItem[]> => {
  let uri = `${process.env.REACT_APP_REST_API_ADDRESS}/api/v1/gift_cards_cardsnacks_cash?amount=${amount}`;
  if (giftCardId) {
    uri += `&gift_card_id=${giftCardId}`;
  }
  const params = {
    method: 'get',
  };
  try {
    const json = await fetch(uri, params)
      .then((response) => response.json())
      .then((data: Record<string, any>) => camelcaseKeys(data, { deep: true }) as IServerCashItemsResponse);
    return json.giftCards.map((item) => ({
      id: item?.id,
      name: item?.name,
      source: item?.source,
      cardImageUrl: item?.imageUrl,
      rank: item?.rank,
      categories: item?.categories,
    }));
  } catch {
    return [];
  }
};

export function* func(action: giftActions.IGiftCashLoadData) {
  const { amount, giftCardId } = action.payload;
  const cashMeta = yield* select((state) => state.gift?.cash?.meta);

  if (cashMeta.amount === amount) {
    yield cancel(); return;
  }

  const data: SagaReturnType<typeof getGiftList> = yield call(() => getGiftList(amount, giftCardId));
  yield put(giftActions.cashSetData(data, amount));
}
